import text from './text.json'
import ListItem from './ListItem'
import {useState} from 'react'
import EditResourceModal from '../../components/pages/resource/EditResourceModal'
import {useDispatch, useSelector} from 'react-redux'
import Checkbox from '../../components/core/checkbox'
import Customer from '../../utils/customer'
import classNames from 'classnames'
import modalTypes from '../../data/modals.json'
import {setActivePopup} from '../../stores/popup'

const ListView = ({
    data,
    selectedData,
    setSelectedData,
    responseTimeData,
    isDarkMode,
    handleModal}) => {
    const [clickedResource, setClickedResource] = useState(null)
    const dispatch = useDispatch()
    const {selectedResources, resources} = useSelector(state => state.resources)
    const activePopup = useSelector(state => state.popup.activePopup)

    const checkAllData = () => {
        const newSelectedData = [...selectedData]
        if (data?.length === selectedData.length) {
            setSelectedData([])
            return
        }
        data.forEach(item => {
            !selectedData.includes(item?.resource_id) && newSelectedData.push(item?.resource_id)
        })
        setSelectedData(newSelectedData)
    }

    return (
        <div className={classNames('grid-view', {
            dark: isDarkMode
        })}>
            {Customer.isOwnTeam() && data?.length > 1 && (
                <div className={classNames({
                    'select-all': true,
                    selected: selectedData?.length === data?.length
                })}>
                    <Checkbox  type="checkbox" onChange={checkAllData} checked={selectedData?.length === data?.length} />
                    <span>{text.select_all}</span>
                </div>
            )}
            <div className={classNames('list-view-container', {
                dark: isDarkMode
            })}>
                {activePopup?.component === modalTypes.uptime_monitoring.editResource.component && (
                    <EditResourceModal
                        closeModal={() => {
                            setClickedResource(null)
                            dispatch(setActivePopup(null))
                        }}
                        title={activePopup.title} isOpen={!!activePopup?.type}
                        contentClassName="overflow-auto"
                        setClickedResource={setClickedResource}
                        resource={clickedResource || resources?.find(item => item?.resource_id === selectedResources[0])}/>
                )}
                {data?.map((item, index) => (
                    <ListItem key={item.resource_id} item={item} clickedResource={clickedResource} responseTimeData={responseTimeData?.[index]} itemCount={data?.length}
                        setClickedResource={setClickedResource} isDarkMode={isDarkMode} handleModal={handleModal}/>
                ))}
            </div>
        </div>
    )
}

export default ListView
